export default function session(state = {}, action) {
  switch (action.type) {
    case 'SET_MOBILE_SIDEBAR_VISIBILITY':
      throw new Error('Deprecated');
    case 'SET_GLOBAL_LOADING_INDICATOR':
      throw new Error('Deprecated');
    case 'GET_USER_DATA':
      // return state.set('USER_DATA', action.value);
      return {
        ...state,
        USER_DATA: action.value,
      };
    case 'SET_LOCALE':
      // return state.set('LOCALE', action.value);
      return {
        ...state,
        LOCALE: action.value,
      };
    case 'SET_CART':
      return {
        ...state,
        CART: action.value,
      };
    case 'SET_WISHLIST':
      return {
        ...state,
        WISHLIST: action.value,
      };
    case 'SET_ME_DATA':
      return {
        ...state,
        POINTS_BALANCE: action.value.pointsBalance,
        USER_DATA: action.value.user,
        LOCALE: action.value.session.localeId,
        SITEID: action.value.session.siteId,
        UNREADMESSAGES: action.value.unreadMessages,
        APPS: action.value.apps,
        CART:
          action.value.cart && action.value.cart.items
            ? action.value.cart.items
            : [],
        WISHLIST:
          action.value.wishlist && action.value.wishlist.items
            ? action.value.wishlist.items
            : [],
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/session.js